import {
  getSuggestion,
  initExternalModule,
  resetChat,
  resetConfig,
  sendNewMessage,
  toggleAppChat,
  toggleCart,
  toggleTooltip,
  updateAppParams,
  updateProductList,
  updateSession,
} from '@/utils';

const sayWhattChat = {
  init: initExternalModule('app'),
  toggleChat: toggleAppChat,
  updateParams: updateAppParams,
  toggleCart: toggleCart,
  updateSession: updateSession,
  sendNewMessage: sendNewMessage,
  resetConfig: resetConfig,
  toggleTooltip: toggleTooltip,
  updateProductList: updateProductList,
  getSuggestion: getSuggestion,
  resetChat: resetChat,
};

window.sayWhattChat = sayWhattChat;

export default sayWhattChat;
